(function ($) {
  const pushExpDataLayer = () => {
    const expSplitData = window.requestContext.expSplitData || [];
    window._expDataLayer = window._expDataLayer || [];
    expSplitData.forEach(data => {
      if (data.experimentId && data.variantId) {
        window._expDataLayer.push({
          schema: 'add_experiment',
          version: 'v1',
          data: {
            experiment_id: data.experimentId,
            variant_id: data.variantId,
            experiment_source: 'SplitIO'
          }
        });
      }
    });
  };
  $(document).ready(pushExpDataLayer);
}(window.jQuery));
